import React, { useRef, useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const GallerySection = () => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  // Photos mixed (intercalated order)
  const photos = [
    { id: 1, url: '/gallery/photo-3.jpg', alt: 'Elit Brand Tour - Networking' },
    { id: 2, url: '/gallery/photo-11.jpg', alt: 'Elit Brand Tour - Asistentes' },
    { id: 3, url: '/gallery/photo-7.jpg', alt: 'Elit Brand Tour - Lenovo F1' },
    { id: 4, url: '/gallery/photo-13.jpg', alt: 'Elit Brand Tour - VR Experience' },
    { id: 5, url: '/gallery/photo-5.jpg', alt: 'Elit Brand Tour - Equipo' },
    { id: 6, url: '/gallery/photo-9.jpg', alt: 'Elit Brand Tour - AMD' },
    { id: 7, url: '/gallery/photo-12.jpg', alt: 'Elit Brand Tour - Catering' },
    { id: 8, url: '/gallery/photo-1.jpg', alt: 'Elit Brand Tour - Conversaciones' },
    { id: 9, url: '/gallery/photo-15.jpg', alt: 'Elit Brand Tour - Salón' },
    { id: 10, url: '/gallery/photo-6.jpg', alt: 'Elit Brand Tour - Asistentes' },
    { id: 11, url: '/gallery/photo-4.jpg', alt: 'Elit Brand Tour - Reuniones' },
    { id: 12, url: '/gallery/photo-14.jpg', alt: 'Elit Brand Tour - Simulador Lenovo F1' },
    { id: 13, url: '/gallery/photo-10.jpg', alt: 'Elit Brand Tour - WD Purple' },
    { id: 14, url: '/gallery/photo-2.jpg', alt: 'Elit Brand Tour - Experiencias' },
    { id: 15, url: '/gallery/photo-8.jpg', alt: 'Elit Brand Tour - Selfies' },
  ];

  const checkScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    checkScroll();
    const ref = scrollRef.current;
    if (ref) {
      ref.addEventListener('scroll', checkScroll);
      return () => ref.removeEventListener('scroll', checkScroll);
    }
  }, []);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = scrollRef.current.clientWidth * 0.8;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Momentos del evento
          </h2>
          <p className="text-lg text-slate-600">
            Una mirada a las experiencias vividas en ediciones anteriores
          </p>
        </div>

        <div className="relative">
          {/* Left arrow */}
          <Button
            onClick={() => scroll('left')}
            disabled={!canScrollLeft}
            className={`absolute left-2 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white hover:bg-slate-100 text-slate-900 shadow-xl border border-slate-200 p-0 transition-all duration-300 ${
              !canScrollLeft ? 'opacity-30 cursor-not-allowed' : 'hover:scale-110'
            }`}
            aria-label="Anterior"
          >
            <ChevronLeft className="w-6 h-6" />
          </Button>

          {/* Right arrow */}
          <Button
            onClick={() => scroll('right')}
            disabled={!canScrollRight}
            className={`absolute right-2 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white hover:bg-slate-100 text-slate-900 shadow-xl border border-slate-200 p-0 transition-all duration-300 ${
              !canScrollRight ? 'opacity-30 cursor-not-allowed' : 'hover:scale-110'
            }`}
            aria-label="Siguiente"
          >
            <ChevronRight className="w-6 h-6" />
          </Button>

          {/* Scroll container */}
          <div
            ref={scrollRef}
            className="overflow-x-auto scrollbar-hide scroll-smooth"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            <div className="flex gap-6 px-4 pb-4">
              {photos.map((photo) => (
                <div
                  key={photo.id}
                  className="flex-shrink-0 w-[85%] sm:w-[60%] md:w-[45%] lg:w-[32%] rounded-2xl overflow-hidden shadow-xl group hover:shadow-2xl transition-all duration-300"
                >
                  <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
                    <img
                      src={photo.url}
                      alt={photo.alt}
                      loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
